// Portfolio content data for Kapil Bhaskar

export const profile = {
  name: "Kapil Bhaskar",
  initials: "KB",
  role: "Statistics & Social Impact",
  school: "Vidya Mandir · Chennai · India",
  grade: "Grade 12 · CBSE",
  email: "KapilBhaskar1451@gmail.com",
  linkedin: "https://www.linkedin.com/in/kapil-bhaskar-2572aa291/",
  neeyosi: "https://neeyosi.com/",
};

export const heroStats = [
  { num: "130K+", lab: "Civic Tech Users" },
  { num: "3", lab: "Research Projects" },
  { num: "1530", lab: "SAT Score" },
  { num: "5/5", lab: "AP Statistics" },
];

export const researchInterests = [
  "Bayesian Statistics",
  "Probabilistic Modelling",
  "Applied Sociology",
  "Civic Technology",
  "Mental Health Informatics",
  "Education Equity",
  "Geospatial Modelling",
  "Electoral Systems",
  "Time-Series Forecasting",
];

export const grade10 = [
  { subject: "Science", score: "100", note: "National 1st", featured: true },
  { subject: "Mathematics", score: "98" },
  { subject: "English", score: "97" },
  { subject: "Sanskrit", score: "97" },
  { subject: "Social Science", score: "93" },
];

export const grade11 = [
  { subject: "Mathematics", score: "92" },
  { subject: "Comp. Sci.", score: "92" },
  { subject: "Chemistry", score: "90" },
  { subject: "English", score: "90" },
  { subject: "Physics", score: "85" },
];

export const standardisedTests = [
  { exam: "SAT", component: "Overall", score: "1530 / 1600", date: "Dec 2025", featured: true },
  { exam: "SAT", component: "Mathematics", score: "780 / 800", date: "Dec 2025" },
  { exam: "SAT", component: "Reading & Writing", score: "750 / 800", date: "Dec 2025" },
  { exam: "AP", component: "Statistics", score: "5 / 5", date: "May 2024", featured: true, star: true },
  { exam: "AP", component: "Psychology", score: "4 / 5", date: "May 2024" },
  { exam: "AP (Upcoming)", component: "Calculus BC · Physics Mech. · CS", score: "—", date: "May 2026", upcoming: true },
];

export const universityPrograms = [
  {
    org: "Johns Hopkins University · 2020–2023",
    badge: "Completed · 4 Courses",
    title: "Center for Talented Youth (CTY)",
    sub: "Selected via SCAT Mathematics Score",
    desc: "Completed four CTY courses across multiple years: Honors Mathematics, Physical Science, Introduction to Java, and Creative Writing. CTY selects students nationally based on exceptional ability in mathematics and verbal reasoning.",
    tags: ["Honors Math", "Physical Science", "Java", "Creative Writing"],
  },
  {
    org: "Northwestern University · 2019",
    badge: "Completed",
    title: "Center for Talent Development (CTD)",
    sub: "Summer Program in Mathematics",
    desc: "Selected to participate in CTD's intensive Summer Program in Mathematics. Focused on above-grade problem solving, mathematical reasoning, and advanced topics beyond the standard curriculum.",
    tags: ["Advanced Mathematics", "Problem Solving", "Northwestern"],
  },
  {
    org: "Ashoka University · May–June 2024",
    badge: "Completed · Full Scholarship",
    title: "Lodha Genius Programme",
    sub: "Selected via Competitive Application · Top-5 in Geometry",
    desc: "One-month residential programme at Ashoka University. Attended advanced courses in Number Theory, Geometry, Experimental Mathematics, and Algebra. Took 4 weekly electives including BioArt using DNA. Placed top-5 in the end-of-programme Geometry exam.",
    tags: ["Number Theory", "Geometry", "SageMath", "Top-5 Geometry"],
    featured: true,
  },
  {
    org: "Awesome Math",
    badge: "Completed",
    title: "Algebra 1.4 — Level 1 Course",
    sub: "Awesome Math Competition Training Programme",
    desc: "Completed Level 1 Algebra course through Awesome Math, a programme focused on olympiad-level mathematics training for competition-oriented students.",
    tags: ["Olympiad Math", "Algebra"],
  },
];

export const featuredInitiative = {
  num: "Featured Initiative",
  status: "Live Platform",
  title: "NeeYosi.com — Civic Technology for Democracy",
  org: "Founder & Developer · Tamil Nadu Assembly Elections, 2026",
  desc: "India's first AI-powered election transparency platform. Aggregated and surfaced candidate credentials, criminal records, assets, and backgrounds for all 4,000+ Tamil Nadu Assembly candidates — in a searchable, multilingual interface accessible to any voter. Reached 130,000 users organically in its first few days, including a feature by Girish Mathrubootham (Founder, Freshworks) on LinkedIn.",
  tags: ["Civic Tech", "AI / NLP", "Open Data", "Electoral Transparency", "130K+ Users"],
  link: "https://neeyosi.com/",
};

export const ongoingResearch = [
  {
    num: "Research Project 01",
    status: "Ongoing",
    title: "Bayesian Cross-Learning in Household Electricity Forecasting",
    org: "Mentored by Dr. Maharshi Dhada · University of Cambridge",
    desc: "Studying Partial Pooling effects in Hierarchical Bayesian AR(24) models under scarce data. Comparing Independent vs. Hierarchical probabilistic models trained on only 2 days of data. Built a leakage-free rolling episode design; working towards journal submission.",
    tags: ["Bayesian Stats", "MCMC", "Python / Stan", "Time Series"],
  },
  {
    num: "Research Project 02",
    status: "Ongoing",
    title: "Geospatial Optimisation of Anganwadi Centres in Tamil Nadu",
    org: "Mentored by Dr. Mudita Upmanyu · Chiron Labs",
    desc: "Demographic model forecasting block-wise demand for early childcare centres in a semi-rural Tamil Nadu district. Uses census data on child population, female literacy, workforce participation, and a socio-economic vulnerability index. Applies non-linear least squares and sensitivity analysis.",
    tags: ["Geospatial", "Census Data", "Optimisation", "Education Equity"],
  },
];

export const internships = [
  {
    num: "Internship 01",
    status: "Completed",
    title: "Mental Health & Lifestyle — Data Science Internship",
    org: "Dr. Shailender Swaminathan · Sapiens Lab, Krea University",
    desc: "Analysed Global Mind Data (100K+ respondents, 200+ variables). Estimated lifestyle–MHQ relationships using OLS with HC3 robust errors. Compared Succeeding (MHQ > 100) vs Struggling (MHQ < 0) cohorts using Cramér's V, SMD, and Absolute Proportion Deltas. Stratified by age group and geography.",
    tags: ["OLS Regression", "Effect-Size", "Mental Health", "100K Dataset"],
  },
  {
    num: "Internship 02",
    status: "Completed",
    title: "Sports Analytics — Cricket Delivery Classification",
    org: "Sports Analytics Team · Chennai Super Kings (IPL)",
    desc: "Built a video-based ML classification model in Python to categorise cricket deliveries by bounce-length (Short / Good / Slot / Full) from hours of CSK net-practice footage. Trained and validated a model for real-time length-category prediction.",
    tags: ["Computer Vision", "Classification", "Python", "IPL"],
  },
  {
    num: "Science Fair",
    status: "2nd Place · State",
    title: "Smart Walking Stick Simulation for the Visually Impaired",
    org: "CBSE Regional Science Exhibition",
    desc: "Built a simulation using an A* path-finding algorithm to plot routes through a pre-defined map, and a live-obstacle detection system using OpenCV trained on real traffic footage — to assist visually impaired navigation.",
    tags: ["A* Algorithm", "OpenCV", "Assistive Tech"],
  },
];

export const manuscripts = [
  {
    type: "Manuscript in Preparation",
    title: "Bayesian Cross-Learning in Household Electricity Demand Forecasting: An Analysis of Partial Pooling under Data-Sparse Conditions",
    authors: "Kapil Bhaskar & Dr. Maharshi Dhada (University of Cambridge)",
    venue: "Target: Statistical journal (pending completion) · 2026",
  },
  {
    type: "Manuscript in Preparation",
    title: "Optimising Early Childhood Care Infrastructure: A Geospatial Demographic Model for Anganwadi Centre Allocation in Tamil Nadu",
    authors: "Kapil Bhaskar & Dr. Mudita Upmanyu (Chiron Labs)",
    venue: "Target: Public policy / applied statistics journal · 2026",
  },
];

export const internshipReports = [
  {
    type: "Data Science Report · Sapiens Lab, Krea University",
    title: "Lifestyle Correlates of Mental Health Quotient: An OLS Analysis of the Global Mind Dataset",
    authors: "Intern Researcher · Under Dr. Shailender Swaminathan",
    venue: "Sapiens Lab · Krea University · Dec 2025 – Feb 2026",
  },
  {
    type: "Technical Report · Chennai Super Kings Analytics",
    title: "Video-Based Delivery Length Classification Model for Net-Practice Footage",
    authors: "Intern Researcher · CSK Sports Analytics Team",
    venue: "Chennai Super Kings · IPL Franchise · May – June 2025",
  },
];

export const skillsStats = [
  {
    group: "Statistical Methods",
    items: [
      { name: "Bayesian Inference / MCMC", level: "Advanced", w: 88 },
      { name: "Probabilistic Modelling", level: "Advanced", w: 85 },
      { name: "OLS Regression & Variants", level: "Advanced", w: 90 },
      { name: "Effect-Size Analysis", level: "Advanced", w: 82 },
      { name: "Geospatial Optimisation", level: "Intermediate", w: 68 },
      { name: "Time-Series Forecasting", level: "Advanced", w: 84 },
    ],
  },
  {
    group: "Programming & Platforms",
    items: [
      { name: "Python", level: "Advanced", w: 92 },
      { name: "Stan (PyStan)", level: "Advanced", w: 85 },
      { name: "pandas / NumPy", level: "Advanced", w: 90 },
      { name: "Matplotlib / Visualisation", level: "Advanced", w: 88 },
      { name: "scikit-learn", level: "Intermediate", w: 70 },
      { name: "MATLAB", level: "Intermediate", w: 65 },
    ],
  },
];

export const toolbox = [
  "Python", "Stan / PyStan", "NumPy", "pandas", "Matplotlib",
  "scikit-learn", "MATLAB", "SageMath", "OpenCV", "Java",
];

// Awards — chronological, grouped by tier
export const awards = [
  // International
  {
    year: "2024",
    tier: "international",
    badge: "International · 2nd Prize",
    title: "ISI Limit International Mathematics Competition",
    org: "Indian Statistical Institute — Category B",
    desc: "Awarded 2nd place in the Category B age division at the ISI Limit exam — one of India's most prestigious mathematics competitions, testing advanced problem-solving at an international level.",
  },
  {
    year: "2024",
    tier: "international",
    badge: "International · 7th at World Finals (Yale)",
    title: "World Scholars Cup — Tournament of Champions",
    org: "Yale University · New Haven, Connecticut",
    desc: "1st in Regional Round (Chennai) → 6th in Global Round (Dubai) → 7th at World Finals at Yale. Competed in debate, essay writing, quiz, and team events among 50,000+ participants from 50+ countries.",
  },
  // National
  {
    year: "2024",
    tier: "national",
    badge: "National \u00b7 100% Scholarship",
    title: "Lodha Genius Programme",
    org: "Ashoka University \u00b7 May \u2013 June 2024",
    desc: "Selected via a competitive nationwide process for the 2024 cohort with a 100% scholarship. Advanced courses in Number Theory, Geometry, Experimental Mathematics, and Algebra. Placed top-5 in the Geometry exam at the end of the programme.",
  },
  {
    year: "2025",
    tier: "national",
    badge: "National · 1st Place",
    title: "CBSE Science — National Topper, Grade 10",
    org: "All India Secondary School Examination (AISSE)",
    desc: "Achieved a perfect score of 100% in Science in the CBSE Class X Board Examination, placing 1st nationally across all AISSE candidates in the subject. Also scored 98% in Mathematics.",
  },
  // State / District
  {
    year: "2025",
    tier: "state",
    badge: "State · 2nd Place",
    title: "CBSE Regional Science Exhibition — Smart Walking Stick",
    org: "CBSE Regional Science Exhibition",
    desc: "Awarded 2nd place for building a simulation of a smart walking stick to assist visually impaired individuals. Used an A* path-finding algorithm to navigate a pre-defined map and a live-obstacle detection system built with OpenCV, trained on real traffic footage.",
  },
  {
    year: "2024 & 2025",
    tier: "district",
    badge: "District · 1st Place (×2)",
    title: "Sciencillations Interschool Science Fair",
    org: "District Level",
    desc: "Won 1st place in consecutive years — 2024 and 2025 — representing Vidya Mandir at the district-level interschool science competition.",
  },
  {
    year: "2025",
    tier: "school",
    badge: "School Leadership",
    title: "School Prefect — Vidya Mandir",
    org: "Nominated by faculty panel",
    desc: "Selected by a panel of teachers as one of the school's best students. Manages 500+ students, bridges student–teacher communication, and organised interschool events with over 2,500 participants.",
  },
];

// Media coverage — actual newspaper headline images
export const mediaNational = [
  {
    publication: "The Hindu BusinessLine",
    section: "Info-Tech",
    brand: "#0a3d62",
    headline: "AI-powered NeeYosi.com puts candidate info at your fingertips",
    sub: "The Hindu Business Line \u00b7 National Business Daily",
    desc: "The Hindu Business Line covers NeeYosi's AI-powered approach to surfacing candidate data, noting how the platform makes hard-to-find government information instantly accessible to voters.",
    url: "https://www.thehindubusinessline.com/info-tech/ai-powered-neeyosicom-puts-candidate-info-at-your-fingertips/article70893116.ece",
    image: "https://customer-assets.emergentagent.com/job_kapil-bhaskar/artifacts/tavhnb1r_HinduBusinessLine.jpg",
  },
  {
    publication: "NDTV",
    section: "National News",
    brand: "#cc0000",
    headline: "How a Teen's Website Helped Tamil Nadu Voters Know About Candidates",
    sub: "NDTV India \u00b7 National Broadcast & Digital",
    desc: "One of India's largest news networks reports on how NeeYosi became a go-to resource for Tamil Nadu voters seeking candidate information during the Assembly Elections.",
    url: "https://www.ndtv.com/india-news/how-a-teens-website-helped-tamil-nadu-voters-know-about-candidates-11405816",
    image: "https://customer-assets.emergentagent.com/job_kapil-bhaskar/artifacts/x39p2d6x_NDTV.jpg",
  },
  {
    publication: "NDTV",
    section: "Personal Interview \u00b7 Live Video",
    brand: "#cc0000",
    headline: "Tamil Nadu Votes Today: Gen Z Voices & NeeYosi Buzz",
    sub: "NDTV Live Video Coverage \u00b7 Polling Day Interview",
    desc: "Personal video interview on NDTV's live polling-day coverage \u2014 highlighting NeeYosi's role in driving informed voting among Gen Z and first-time voters in Tamil Nadu.",
    url: "https://www.ndtv.com/videos/tamil-nadu-votes-today-5-6-crore-electors-women-lead-gen-z-voices-neeyosi-buzz-1089011",
  },
  {
    publication: "TechStory",
    section: "Startup & Tech",
    brand: "#0a8754",
    headline: "Chennai-based NeeYosi.com crosses 20,000 users within 24 hours of launch",
    sub: "TechStory \u00b7 India's Tech Startup Media",
    desc: "TechStory reports on NeeYosi's remarkable organic growth \u2014 20,000 users in the first 24 hours with no advertising spend \u2014 framing it as one of the standout civic-tech launches in recent memory.",
    url: "https://techstory.in/chennai-based-website-neeyosi-com-crosses-20000-users-within-24-hours-of-launch/",
    image: "https://customer-assets.emergentagent.com/job_kapil-bhaskar/artifacts/s444whz1_TechStory.jpg",
  },
];

export const mediaRegional = [
  {
    publication: "Mylapore Times",
    section: "Local News",
    brand: "#7b3f00",
    headline: "Vidya Mandir's Kapil Bhaskar builds voter info platform; people are checking it out",
    sub: "Mylapore Times \u00b7 Chennai Community Paper",
    desc: "Chennai's beloved neighbourhood paper profiles Kapil as a local student making waves, with the platform gaining thousands of users on polling eve.",
    url: "https://www.mylaporetimes.com/2026/04/vidya-mandirs-kapil-bhaskar-builds-voter-info-platform-users-flowing-in-on-polling-eve/",
    image: "https://customer-assets.emergentagent.com/job_kapil-bhaskar/artifacts/u8yau23j_MylaporeTimes.jpg",
  },
  {
    publication: "YOCee",
    section: "Youth Newsroom",
    brand: "#4f3a9c",
    headline: "Vote Informed \u2014 Kapil Bhaskar's website provides access to all the information of election candidates",
    sub: "YOCee \u00b7 Chennai's Youth Journalism Platform",
    desc: "YOCee \u2014 a platform run by and for young people \u2014 covers NeeYosi as a powerful example of youth civic engagement, framing it as a call to action for informed voting.",
    url: "https://yocee.in/neeyosi-a-youths-call-for-informed-voting",
    image: "https://customer-assets.emergentagent.com/job_kapil-bhaskar/artifacts/251568c7_Yocee.jpg",
  },
  {
    publication: "Tell My Story",
    section: "Feature",
    brand: "#5a3e85",
    headline: "Nee Yosi Effect: How a Chennai Teen Helped Voters Navigate 4,000+ Candidates",
    sub: "Tell My Story \u00b7 Digital Feature Magazine",
    desc: "A longform feature on how NeeYosi solved a real democratic problem \u2014 helping ordinary voters cut through the noise of 4,000+ Assembly candidates to find the information they needed.",
    url: "https://tellmystory.in/nee-yosi-effect-how-a-chennai-teen-helped-voters-navigate-4000-candidates/",
  },
];

export const navItems = [
  { id: "about", label: "About" },
  { id: "research", label: "Research" },
  { id: "awards", label: "Awards & Scholarships" },
  { id: "leadership", label: "Leadership & Activities" },
  { id: "social", label: "Community Impact" },
  { id: "media", label: "Press & Recognition" },
];

// Leadership & Activities (ordered per spec: top 3 = Prefect, Editorial Board, Pickleball)
export const leadership = [
  {
    category: "School Leadership",
    title: "School Prefect \u2014 Vidya Mandir",
    sub: "Elected position \u00b7 2025\u201326",
    desc: "Elected to the position of Prefect at Vidya Mandir. I help organise major student events including the school culturals and the academy, while also amplifying student issues to the management and driving outcomes. The role blends event leadership, peer representation, and the day-to-day work of bridging students and faculty.",
    tags: ["Elected", "Student Culturals", "The Academy", "Student\u2013Faculty Liaison"],
  },
  {
    category: "Editorial",
    title: "Editorial Board \u2014 Dhwani, School Magazine",
    sub: "2 years \u00b7 Team of 6 Student Editors",
    desc: "Dhwani is Vidya Mandir's school magazine, run by a team of six student editors. I have served on the editorial board for two years \u2014 writing numerous articles, curating contributions from across the school, and shaping each issue. The magazine is an important tool to drive student opinion and outcomes within the school.",
    tags: ["Writer", "Curator", "2 years on Board", "6-editor team"],
  },
  {
    category: "Community Initiative",
    title: "Youth Pickleball Club \u2014 Founder",
    sub: "Boys Fitness Club \u00b7 Pickleball + Badminton",
    desc: "Founder of a boys fitness club where members play pickleball and badminton twice a week. What started as a handful of boys meeting after school has now grown into a community group with members from 3 different schools in the area meeting after-school \u2014 also building genuine camaraderie between schools.",
    tags: ["Founder", "3 schools", "Twice-weekly", "Cross-school community"],
  },
  {
    category: "International Competition",
    title: "World Scholars Cup \u2014 Tournament of Champions, Yale",
    sub: "Debate \u00b7 Quiz \u00b7 Essay \u00b7 Team Events",
    desc: "1st in Regional Round (Chennai) \u2192 6th in Global Round (Dubai) \u2192 7th at the World Finals at Yale University. Competed against 50,000+ participants from 50+ countries.",
    tags: ["Yale", "50K+ competitors", "50+ countries"],
  },
  {
    category: "Sports \u00b7 Captain",
    title: "Basketball \u2014 Captain & Point Guard",
    sub: "Vidya Mandir School Team",
    desc: "Captain of the school basketball squad. Led the team to wins in 3 tournaments and to the school's first-ever home-ground tournament title. Plays point guard \u2014 the floor-general role.",
    tags: ["Captain", "Point Guard", "3 tournament wins"],
  },
  {
    category: "Sports",
    title: "Cricket \u2014 Opening Batsman & Bowler",
    sub: "Vidya Mandir School Team",
    desc: "Opens the batting and bowls for the school cricket team. Multiple Man-of-the-Match awards across interschool fixtures.",
    tags: ["Opening Batsman", "Bowler", "Man of the Match"],
  },
  {
    category: "Music",
    title: "Keyboard \u2014 Trinity Grade 4 with Distinction",
    sub: "Trinity College London \u00b7 Concerts & School Band",
    desc: "Achieved Trinity College London Grade 4 in Electronic Keyboard with Distinction. Formed a band with classmates and performed at school concerts and inter-school music competitions.",
    tags: ["Trinity Grade 4", "Distinction", "Band Member"],
  },
  {
    category: "Community Service",
    title: "Scribe for Specially-Abled Students",
    sub: "Volunteer \u00b7 Board Examinations",
    desc: "Volunteers as a scribe for specially-abled students writing their board examinations \u2014 an experience that shaped a personal commitment to education equity and informs ongoing research with Chiron Labs.",
    tags: ["Volunteer", "Education Equity"],
  },
];
